import { toCustomerError } from '../utils/customerError';
import { API_BASE_URL } from '../config/apiEndpoints';

const parseError = async (response) => {
  try {
    const data = await response.json();
    return toCustomerError(data?.detail || data?.message, { status: response.status });
  } catch {
    return toCustomerError('', { status: response.status });
  }
};

class BookingFeedbackApiService {
  async getBookingFeedback(bookingId, authHeaders = {}) {
    const response = await fetch(`${API_BASE_URL}/bookings/${bookingId}/feedback`, {
      headers: { ...authHeaders },
    });
    if (!response.ok) throw new Error(await parseError(response));
    return response.json();
  }

  async sendFeedbackRequest(bookingId, authHeaders = {}) {
    const response = await fetch(`${API_BASE_URL}/bookings/${bookingId}/send-feedback-request`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeaders },
    });
    if (!response.ok) throw new Error(await parseError(response));
    return response.json();
  }

  async getFeedbackForm(bookingId, token) {
    const params = new URLSearchParams({ token });
    const response = await fetch(
      `${API_BASE_URL}/bookings/${bookingId}/feedback-form?${params.toString()}`
    );
    if (!response.ok) throw new Error(await parseError(response));
    return response.json();
  }

  async submitFeedback(bookingId, { token, rating, comment }) {
    const params = new URLSearchParams({ token });
    const response = await fetch(
      `${API_BASE_URL}/bookings/${bookingId}/feedback?${params.toString()}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ rating, comment: comment || '' }),
      }
    );
    if (!response.ok) throw new Error(await parseError(response));
    return response.json();
  }
}

const bookingFeedbackApiService = new BookingFeedbackApiService();
export default bookingFeedbackApiService;
